import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data ? props.data.title : "Skill Share - Peer to Peer Learning Platform"}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : "Enhance Your Skills in Tech"}</p>
                <a
                  href="#dashboard"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Learn More
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};